import { Alert, Box, CircularProgress, TextField, Typography } from '@mui/material';
import React from 'react';
import { SECONDARY_BUTTON_HOVER_SX, StyledButton } from '../../styles/StyledButtons';

interface DocumentUploadPendingFormProps {
  file: File;
  title: string;
  uploading: boolean;
  uploadError: string | null;
  onTitleChange: (v: string) => void;
  onUpload: () => void;
  onClear: () => void;
  onDismissError: () => void;
}

/** Title + confirm UI once a document has been chosen. */
export default function DocumentUploadPendingForm({
  file,
  title,
  uploading,
  uploadError,
  onTitleChange,
  onUpload,
  onClear,
  onDismissError,
}: DocumentUploadPendingFormProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <TextField
        label="Document title"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        size="small"
        fullWidth
        disabled={uploading}
      />
      <Typography variant="caption" color="text.secondary">
        {file.name}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <StyledButton
          noTopSpacing
          onClick={onUpload}
          disabled={uploading || !title.trim()}
          startIcon={
            uploading ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : undefined
          }
        >
          {uploading ? 'Uploading…' : 'Upload'}
        </StyledButton>
        <StyledButton
          noTopSpacing
          buttonVariant="inactiveOrCancel"
          sx={SECONDARY_BUTTON_HOVER_SX}
          onClick={onClear}
          disabled={uploading}
        >
          Cancel
        </StyledButton>
      </Box>
      {uploadError && (
        <Alert severity="error" onClose={onDismissError} sx={{ py: 0 }}>
          {uploadError}
        </Alert>
      )}
    </Box>
  );
}
